(ns assemble.component.filter-panel
  (:require ["@mui/x-data-grid-premium" :as data-grid :refer [GridAddIcon GridDeleteForeverIcon GridFilterListIcon]]
            ["react" :as react]))

(defn RemoveAllIconSlot [^js props]
  (let [new-props (js/Object.assign #js {:data-testid "removeAll"} props)]
    (react/createElement GridDeleteForeverIcon new-props)))

(defn AddIconSlot [^js props]
  (let [new-props (js/Object.assign #js {:data-testid "addFilterButton"} props)]
    (react/createElement GridAddIcon new-props)))

(defn OpenFilterIconSlot [^js props]
  (let [new-props (js/Object.assign #js {:data-testid "filtersButton"} props)]
    (react/createElement GridFilterListIcon new-props)))
